import { render, staticRenderFns } from "./business-object.vue?vue&type=template&id=1be9abf2&scoped=true&lang=html&"
import script from "./business-object.vue?vue&type=script&lang=js&"
export * from "./business-object.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be9abf2",
  null
  
)

export default component.exports